(function () {
  var REGION_SUFFIXES = ['-af-a', '-ze-a', '-ae-a', '-qa-a', '-zd-a', '-aa-a', '-am-a', '-ls-a'];
  var ACCESSORY_RE = /case|magsafe|band|bumper|cable|charger|sleeve|folio|cover|loop|braided|adapter|pencil|keyboard|mouse|trackpad|screen|protector|wallet|finewoven|techwoven|silicone/i;
  var MODEL_EXTRAS = ['pro', 'max', 'plus', 'air', 'mini', 'ultra', 'neo', 'se', 'duo', 'e'];
  var FOREIGN_HOST_RE = /(^|\.)myshopify\.com$|(^|\.)switchplus/i;
  var cache = {};
  var pending = [];
  var ready = false;
  var storeOrigin = window.location.origin;

  function tokens(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\b(\d+)-in\.?/g, '$1 inch')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .filter(function (tok) {
        return ['in', 'generation', 'the', 'with', 'and', 'or'].indexOf(tok) === -1;
      });
  }

  function slugify(value) {
    return tokens(value).join('-');
  }

  function productNameFromButton(el) {
    var label = el.getAttribute('aria-label') || '';
    var match = label.match(/buy[,]?\s*(.+)/i);
    if (match && match[1]) return match[1].trim();
    return (el.id || '').replace(/-/g, ' ').trim();
  }

  function isAccessory(product) {
    var title = product.title || '';
    var handle = product.handle || '';
    return ACCESSORY_RE.test(title) || ACCESSORY_RE.test(handle);
  }

  function hasPositivePrice(product) {
    if (!product) return false;
    var variants = product.variants;
    if (Array.isArray(variants) && variants.length) {
      return variants.some(function (variant) {
        var raw = variant && variant.price;
        if (raw == null || raw === '' || raw === 0 || raw === '0' || raw === '0.00') return false;
        var amount = Number(raw);
        return !Number.isNaN(amount) && amount > 0;
      });
    }
    var price = Number(product.price || product.price_min || product.price_max || 0);
    return !Number.isNaN(price) && price > 0;
  }

  function scoreProduct(name, product) {
    if (!product || isAccessory(product) || !hasPositivePrice(product)) return -1;
    var query = tokens(name);
    var hay = tokens((product.title || '') + ' ' + String(product.handle || '').replace(/-[a-z0-9]{3,8}[a-z]{2}-a$/i, ''));
    if (!query.length) return -1;
    for (var i = 0; i < query.length; i++) {
      if (hay.indexOf(query[i]) === -1) return -1;
    }
    var extra = 0;
    MODEL_EXTRAS.forEach(function (token) {
      if (hay.indexOf(token) !== -1 && query.indexOf(token) === -1) extra += 1;
    });
    var skip = { gb: 1, tb: 1, wifi: 1, cellular: 1 };
    hay.forEach(function (tok) {
      if (query.indexOf(tok) === -1 && !skip[tok] && !/^\d+$/.test(tok) && MODEL_EXTRAS.indexOf(tok) === -1) {
        extra += 0.15;
      }
    });
    return 100 - extra * 25;
  }

  function pickBest(name, products) {
    var best = null;
    var bestScore = 49;
    (products || []).forEach(function (product) {
      var score = scoreProduct(name, product);
      if (score > bestScore) {
        bestScore = score;
        best = product;
      }
    });
    return best;
  }

  function jsonFetch(path) {
    return fetch(storeOrigin + path, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  /** Relative catalog URL — never hardcode another store host (Apple Numbers 56/71/101/116). */
  function productUrl(handle) {
    return '/products/' + handle;
  }

  function collectionUrl(handle) {
    return '/collections/' + handle;
  }

  function toRelativeCatalogUrl(href) {
    var raw = String(href || '').trim();
    if (!raw || raw === '#' || raw.indexOf('javascript:') === 0) return raw;
    if (raw.charAt(0) === '/' && raw.indexOf('//') !== 0) return raw;
    try {
      var url = new URL(raw, storeOrigin);
      var path = url.pathname + url.search + url.hash;
      if (path.indexOf('/products/') === 0 || path.indexOf('/collections/') === 0) {
        return path;
      }
      if (url.origin !== storeOrigin && FOREIGN_HOST_RE.test(url.hostname)) {
        return path;
      }
      if (url.origin === storeOrigin) {
        return path || raw;
      }
    } catch (e) {
      /* keep raw */
    }
    return raw;
  }

  function stripForeignHosts(doc) {
    compareButtons(doc).forEach(function (el) {
      var href = el.getAttribute('href');
      var relative = toRelativeCatalogUrl(href);
      if (relative && relative !== href) {
        el.setAttribute('href', relative);
      }
    });
  }

  function lookupProduct(handle) {
    var key = 'p:' + handle;
    if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    return jsonFetch('/products/' + encodeURIComponent(handle) + '.js').then(function (data) {
      cache[key] = data && data.handle && hasPositivePrice(data) ? productUrl(data.handle) : null;
      return cache[key];
    });
  }

  function collectionProducts(handle) {
    var key = 'cp:' + handle;
    if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    return jsonFetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50').then(function (data) {
      cache[key] = (data && data.products) || [];
      return cache[key];
    });
  }

  function suffixVariants(handle) {
    var base = String(handle || '').replace(/-[a-z]{2}-a$/i, '');
    if (base === handle) return [];
    return REGION_SUFFIXES.map(function (suffix) {
      return base + suffix;
    });
  }

  function collectionCandidates(handle, name) {
    var seen = {};
    var list = [];
    function add(value) {
      if (!value || seen[value]) return;
      seen[value] = true;
      list.push(value);
    }
    var family = String(handle || '').replace(/-[a-z0-9]{3,8}[a-z]{2}-a$/i, '');
    add(family);
    add(handle);
    var slug = slugify(name || '');
    add(slug);
    if (slug.indexOf('-pro-max') !== -1) add(slug.replace(/-pro-max$/, '-pro'));
    if (slug.indexOf('-plus') !== -1) add(slug.replace(/-plus$/, ''));
    var parts = slug.split('-');
    if (parts[0] && /^\d+$/.test(parts[0]) && parts.indexOf('inch') !== -1) {
      add(parts.slice(2).join('-'));
    }
    if (parts.indexOf('macbook') !== -1) {
      if (parts.indexOf('air') !== -1) add('macbook-air');
      if (parts.indexOf('pro') !== -1) add('macbook-pro');
      if (parts.indexOf('neo') !== -1) add('macbook-neo');
    }
    if (parts.indexOf('imac') !== -1) add('imac');
    if (parts.indexOf('mini') !== -1 && parts.indexOf('mac') !== -1) add('mac-mini');
    if (parts.indexOf('studio') !== -1) add('mac-studio');
    if (parts.indexOf('ipad') !== -1) {
      if (parts.indexOf('air') !== -1) add('ipad-air');
      else if (parts.indexOf('pro') !== -1) add('ipad-pro');
      else if (parts.indexOf('mini') !== -1) add('ipad-mini');
      else add('ipad');
    }
    if (parts.indexOf('airpods') !== -1) {
      add('airpods');
      add(slug);
    }
    while (parts.length > 1) {
      parts.pop();
      add(parts.join('-'));
    }
    return list;
  }

  function searchProducts(name) {
    var key = 's:' + name;
    if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    var path =
      '/search/suggest.json?' +
      'q=' + encodeURIComponent(name) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=show';
    return jsonFetch(path).then(function (data) {
      var products = (((data || {}).resources || {}).results || {}).products || [];
      cache[key] = products;
      return products;
    });
  }

  function resolveByName(name, handleHint) {
    if (!name && !handleHint) return Promise.resolve(null);
    var candidates = collectionCandidates(handleHint || '', name || '');
    return candidates
      .reduce(function (promise, collectionHandle) {
        return promise.then(function (resolved) {
          if (resolved) return resolved;
          return collectionProducts(collectionHandle).then(function (products) {
            var best = pickBest(name || handleHint, products);
            return best ? productUrl(best.handle) : null;
          });
        });
      }, Promise.resolve(null))
      .then(function (resolved) {
        if (resolved || !name) return resolved;
        return searchProducts(name).then(function (products) {
          var best = pickBest(name, products);
          return best ? productUrl(best.handle) : null;
        });
      });
  }

  function resolveTarget(href, name) {
    var raw = toRelativeCatalogUrl(String(href || '').trim());
    var url = null;
    if (raw && raw !== '#' && raw.indexOf('javascript:') !== 0) {
      try {
        url = new URL(raw, storeOrigin);
      } catch (e) {
        url = null;
      }
    }
    var type = url ? url.pathname.replace(/\/+$/, '').split('/')[1] : '';
    var handle = url ? decodeURIComponent(url.pathname.replace(/\/+$/, '').split('/')[2] || '') : '';

    var start = Promise.resolve(null);
    if (type === 'products' && handle) {
      start = lookupProduct(handle).then(function (found) {
        if (found) return found;
        return suffixVariants(handle).reduce(function (promise, nextHandle) {
          return promise.then(function (resolved) {
            if (resolved) return resolved;
            return lookupProduct(nextHandle);
          });
        }, Promise.resolve(null));
      });
    } else if (type === 'collections' && handle) {
      start = collectionProducts(handle).then(function (products) {
        var best = pickBest(name || handle, products);
        if (best) return productUrl(best.handle);
        if (products.length) return collectionUrl(handle);
        return null;
      });
    }

    return start.then(function (resolved) {
      if (resolved) return toRelativeCatalogUrl(resolved);
      return resolveByName(name, handle).then(function (byName) {
        return byName ? toRelativeCatalogUrl(byName) : null;
      });
    });
  }

  function dashMarkup(label) {
    var hidden = label ? '<p class="visuallyhidden">' + label + '</p>' : '';
    return (
      '<div class="mdash-container">' +
      '<p class="mdash copy" aria-hidden="true">&mdash;</p>' +
      hidden +
      '</div>'
    );
  }

  function applyButton(el, href, name) {
    el.setAttribute('data-compare-buy-ready', 'true');
    if (href) {
      el.setAttribute('href', toRelativeCatalogUrl(href));
      el.setAttribute('target', '_parent');
      el.classList.remove('is-disabled');
      el.removeAttribute('aria-disabled');
      return;
    }
    var container = el.closest('.button-container, .button_river-container') || el.parentElement;
    if (container) {
      container.innerHTML = dashMarkup(name ? name + ' is not available' : 'Not Applicable');
    }
  }

  function compareButtons(doc) {
    return Array.prototype.slice.call(
      doc.querySelectorAll('a.compare-button, a.compare-button_river, a[class*="compare-button"]')
    );
  }

  function walkBuyItems(node, visit) {
    if (!node || typeof node !== 'object') return;
    if (node.template === 'preview-item-button') {
      visit(node);
      return;
    }
    if (Array.isArray(node)) {
      node.forEach(function (child) {
        walkBuyItems(child, visit);
      });
      return;
    }
    Object.keys(node).forEach(function (key) {
      walkBuyItems(node[key], visit);
    });
  }

  function patchCompareData(win) {
    var instances = win.channelHtml && win.channelHtml.channelCompare && win.channelHtml.channelCompare.instances;
    if (!instances) return Promise.resolve();
    var jobs = [];
    Object.keys(instances).forEach(function (id) {
      var inst = instances[id];
      var products = inst && inst.compareData && inst.compareData.products;
      if (!products) return;
      Object.keys(products).forEach(function (key) {
        var product = products[key];
        var name = product.productName || '';
        walkBuyItems(product, function (item) {
          jobs.push(
            resolveTarget(item.value, name).then(function (href) {
              item.value = href || '';
            })
          );
        });
      });
    });
    return Promise.all(jobs).then(function () {
      Object.keys(instances).forEach(function (id) {
        var inst = instances[id];
        if (!inst || !inst.dropdowns || typeof inst._updateProduct !== 'function') return;
        Array.prototype.forEach.call(inst.dropdowns, function (dropdown, index) {
          var value = Number(dropdown.value);
          if (!Number.isNaN(value)) inst._updateProduct(index, value);
        });
      });
    });
  }

  function waitForCompare(win) {
    return new Promise(function (resolve) {
      var tries = 0;
      function tick() {
        var instances = win.channelHtml && win.channelHtml.channelCompare && win.channelHtml.channelCompare.instances;
        var hasData = instances && Object.keys(instances).some(function (id) {
          return instances[id] && instances[id].compareData;
        });
        if (hasData || tries > 20) {
          resolve();
          return;
        }
        tries += 1;
        setTimeout(tick, 100);
      }
      tick();
    });
  }

  var HIDE_UNRESOLVED_CSS =
    'a.compare-button:not([data-compare-buy-ready="true"]),a.compare-button_river:not([data-compare-buy-ready="true"]),a[class*="compare-button"]:not([data-compare-buy-ready="true"]){visibility:hidden}';

  function injectHideStyle(doc) {
    if (!doc || !doc.head || doc.getElementById('compare-buy-hide-unresolved')) return;
    var style = doc.createElement('style');
    style.id = 'compare-buy-hide-unresolved';
    style.textContent = HIDE_UNRESOLVED_CSS;
    doc.head.appendChild(style);
  }

  function resolvePendingButtons(doc) {
    compareButtons(doc).forEach(function (el) {
      if (el.getAttribute('data-compare-buy-ready') === 'true' || el.getAttribute('data-compare-buy-pending') === 'true') return;
      el.setAttribute('data-compare-buy-pending', 'true');
      var name = productNameFromButton(el);
      resolveTarget(el.getAttribute('href'), name)
        .then(function (href) {
          applyButton(el, href, name);
        })
        .catch(function () {
          el.setAttribute('data-compare-buy-ready', 'true');
        });
    });
  }

  // Buttons re-rendered by compare dropdowns are new unresolved nodes; resolve them (cached) so they don't stay hidden.
  function watchDocument(doc) {
    if (!doc || doc.__compareBuyWatch || typeof MutationObserver === 'undefined' || !doc.documentElement) return;
    doc.__compareBuyWatch = true;
    var timer = null;
    new MutationObserver(function () {
      if (timer || doc.documentElement.getAttribute('data-compare-buy-resolved') !== 'true') return;
      timer = setTimeout(function () {
        timer = null;
        resolvePendingButtons(doc);
      }, 30);
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  // Buy clicked before async resolve finishes must not follow the raw (possibly 404) handle.
  function bindClickGuard(doc) {
    if (!doc || doc.__compareBuyClickGuard) return;
    doc.__compareBuyClickGuard = true;
    injectHideStyle(doc);
    watchDocument(doc);
    doc.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        var el = target && target.closest ? target.closest('a.compare-button, a.compare-button_river, a[class*="compare-button"]') : null;
        if (!el || el.getAttribute('data-compare-buy-ready') === 'true') return;
        event.preventDefault();
        event.stopPropagation();
        var name = productNameFromButton(el);
        resolveTarget(el.getAttribute('href'), name).then(function (href) {
          applyButton(el, href, name);
          if (href) window.location.assign(toRelativeCatalogUrl(href));
        });
      },
      true
    );
  }

  function resolveDocument(doc) {
    bindClickGuard(doc);
    if (!doc || (doc.documentElement && doc.documentElement.getAttribute('data-compare-buy-resolved') === 'true')) {
      return Promise.resolve();
    }
    // Sync: kill cross-store absolute Buy URLs before async resolve (no flash).
    stripForeignHosts(doc);
    if (doc.documentElement) doc.documentElement.setAttribute('data-compare-buy-resolved', 'pending');
    var win = doc.defaultView || window;
    return waitForCompare(win)
      .then(function () {
        return patchCompareData(win);
      })
      .then(function () {
        stripForeignHosts(doc);
        return Promise.all(
          compareButtons(doc).map(function (el) {
            var name = productNameFromButton(el);
            return resolveTarget(el.getAttribute('href'), name).then(function (href) {
              applyButton(el, href, name);
            });
          })
        );
      })
      .then(function () {
        if (doc.documentElement) doc.documentElement.setAttribute('data-compare-buy-resolved', 'true');
      })
      .catch(function () {
        if (doc.documentElement) doc.documentElement.removeAttribute('data-compare-buy-resolved');
        compareButtons(doc).forEach(function (el) {
          el.setAttribute('data-compare-buy-ready', 'true');
        });
      });
  }

  function resolveCompareBuy(doc) {
    if (!doc) return Promise.resolve();
    stripForeignHosts(doc);
    bindClickGuard(doc);
    if (!ready) {
      pending.push(doc);
      return Promise.resolve();
    }
    return resolveDocument(doc);
  }

  window.switchPlusResolveCompareBuy = resolveCompareBuy;

  function flush() {
    ready = true;
    pending.splice(0).forEach(function (doc) {
      resolveDocument(doc);
    });
    if (document.querySelector('.channel-compare, .compare-button, .compare-button_river, [class*="compare-button"]')) {
      resolveDocument(document);
    }
  }

  // Catch late-injected compare Buy links (iframe / channel re-render).
  if (typeof MutationObserver !== 'undefined' && document.documentElement) {
    var moTimer = null;
    var observer = new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () {
        moTimer = null;
        if (!document.querySelector('a.compare-button, a.compare-button_river, a[class*="compare-button"]')) return;
        stripForeignHosts(document);
        if (ready) resolveDocument(document);
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flush);
  } else {
    flush();
  }
})();
